export const getQuerySearchParam = (name: string): string | null => {
  const params = (new URL(document.location.toString())).searchParams
  return params.get(name)
}

export const getQueryFilterValue = (filterName = 'status', defaultVal = 'ALL'): string => {
  const params = (new URL(document.location.toString())).searchParams
  const filterVal = params.get(filterName)
  return (filterVal && filterVal !== defaultVal)
    ? filterVal
    : defaultVal
}

interface DateFilterValue {
  from: string
  to: string
}
export const getDateFilterValue = (fromStr = 'from', toStr = 'to'): DateFilterValue => {
  const from = getQuerySearchParam(fromStr)
  const to = getQuerySearchParam(toStr)
  return {
    from: typeof from === 'string' && from !== '' ? from : '',
    to: typeof to === 'string' && to !== '' ? to : '',
  }
}

export const getQueryParamsObject = (): unknown => {
  const searchParams = new URLSearchParams(window.location.search)
  return Array.from(searchParams.keys()).reduce(
    (acc, val) => ({ ...acc, [val]: searchParams.get(val) }),
    {},
  )
}

export const updateUrlParameter = (url: string, param: string, value: string): string => {
  const pattern = new RegExp(param + '=.*?(&|$)', 'i')
  let newUrl = url.replace(pattern, param + '=' + value + '$1')

  if (url === newUrl) {
    const separator = url.indexOf('?') !== -1 ? '&' : '?'
    newUrl = url + separator + param + '=' + value
  }

  return newUrl
}

export const updateUrlParameters = (url: string, params: Record<string, any>) => {
  const urlObject = new URL(url)
  const urlSearchParams = urlObject.searchParams

  for (const [key, value] of Object.entries(params)) {
    if (value !== undefined && value !== null) {
      urlSearchParams.set(key, value)
    }
  }
  return urlObject.toString()
}

